import { Link, useRouterState } from '@tanstack/react-router';
import { LayoutDashboard, Building2, Activity, MoreHorizontal } from 'lucide-react';
import { cn } from '../../lib/cn.js';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { to: '/landlords', label: 'Landlords', icon: Building2, exact: false },
  { to: '/activity', label: 'Activity', icon: Activity, exact: false },
  { to: '/kanban', label: 'Board', icon: MoreHorizontal, exact: false },
];

export function BottomNav() {
  const router = useRouterState();
  const current = router.location.pathname;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-border flex sm:hidden"
      aria-label="Main navigation"
    >
      {NAV_ITEMS.map((item) => {
        const isActive = item.exact ? current === item.to : current.startsWith(item.to);
        const Icon = item.icon;
        return (
          <Link
            key={item.to}
            to={item.to}
            className={cn(
              'flex-1 flex flex-col items-center justify-center py-2 gap-0.5 min-h-[56px] transition-colors',
              isActive ? 'text-primary' : 'text-secondary'
            )}
            aria-label={item.label}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
